import { Injectable } from '@angular/core';
import { ApiService } from 'app/core/services/apiservice';
import { DocumentosGeneradosResponse } from '../../bienes-culturales/detalle-bien-cultural/tabs/documentos-emitidos/models/response-documento-generado';
import { BehaviorSubject } from 'rxjs';
import { FilterParamsDocumentosGenerados } from '../models/filter-params-documentos';
import { TipologiasInterface } from 'app/models/tipologias.model';
import { ElementosVinculadosInterface } from 'app/models/elementos-vinculados-model';
import { BitacoraActividadesInterface } from 'app/models/bitacora.model';

@Injectable({providedIn: 'root'})
export class DocumentosOficialesService {
    ListaDocumentosGenerados: BehaviorSubject<DocumentosGeneradosResponse>= new BehaviorSubject<DocumentosGeneradosResponse>(null)
    elementosVinculadosDocumentos: BehaviorSubject<ElementosVinculadosInterface[]> = new BehaviorSubject<ElementosVinculadosInterface[]>([])
    listaDocumentosOficialesFilterParams: BehaviorSubject<FilterParamsDocumentosGenerados> = new BehaviorSubject(null)
    bitacorasDocumento = new BehaviorSubject<BitacoraActividadesInterface[]>([]);

    get ListaDocumentosGenerados$(){
        return this.ListaDocumentosGenerados.asObservable()
    }

    set documentosOficialesFilterParmas(value: any) {
        this.listaDocumentosOficialesFilterParams.next(value);
    }

    get documentosOficialesFilterParmasValue() {
        return this.listaDocumentosOficialesFilterParams.getValue()
    }

    get elementosVinculadosDocumentos$(){
        return this.elementosVinculadosDocumentos.asObservable()
    }

    get bitacorasDocumento$(){
        return this.bitacorasDocumento.asObservable();
    }

    constructor(private apiService: ApiService) { }
    
    getListaDocumentosOficiales(params:FilterParamsDocumentosGenerados){
            const url='/documento_generado/'
            return new Promise((resolve, reject)=>{
                this.apiService.GetMethod(url, params, 'Error al obtener los datos.')
                    .subscribe((response: DocumentosGeneradosResponse) => {
                        this.ListaDocumentosGenerados.next(response)
                        resolve(response)                    
                    }, error => {
                        reject(true)
                    })
            })
        }

    getTipologias(tipologia_id:number){
        const url= `/tipologias/${tipologia_id}` 
        return new Promise((resolve, reject)=>{
            this.apiService.GetMethod(url, {}, 'Error obtener tipología.')
                .subscribe((response:TipologiasInterface) => {
                    resolve(response[0].tipologias)  
                }, error => {
                    reject(error)
                })
        })
    }

    getElementosVinculados(task_uuid: string){
        const url=`/vinculo/${task_uuid}`
        return new Promise((resolve, reject)=>{
            this.apiService.GetMethod(url, {}, 'Error al obtener los elementos vínculados.')
                .subscribe((response: ElementosVinculadosInterface[]) => {
                    this.elementosVinculadosDocumentos.next(response)
                    resolve(response)                  
                }, error => {
                    reject(true)
                })
        })
    }

    getBitacoraBienesDocumentos(_entidadUuid:string){
        const url='/bitacoras'
        const params= {entidadUuid:_entidadUuid}
        return new Promise((resolve, reject)=>{
            this.apiService.GetMethod(url, params, 'Error al obtener los datos.')
                .subscribe((response: any) => {
                    this.bitacorasDocumento.next(response.data);  
                    resolve(response)   
                }, error => {
                    reject(true)
                })
        })
    }



}